module.exports = __webpack_public_path__ + "img/drop-icon.7cc1930c.svg";